export const customers = {
  title: 'Clients',
  description: 'Gérez vos clients',
  form: {
    createTitle: 'Nouveau client',
    editTitle: 'Modifier le client',
    fields: {
      name: 'Nom',
      email: 'Email',
      phone: 'Téléphone',
      address: 'Adresse',
      notes: 'Notes',
      isActive: 'Actif',
      solde: 'Solde'
    },
    placeholders: {
      name: 'Entrez le nom du client',
      email: 'Entrez l\'email du client',
      phone: 'Entrez le numéro de téléphone',
      address: 'Entrez l\'adresse',
      notes: 'Ajoutez des notes sur le client'
    },
    validations: {
      required: 'Ce champ est requis',
      email: 'Veuillez entrer une adresse email valide',
      phone: 'Veuillez entrer un numéro de téléphone valide',
      minLength: 'Ce champ doit contenir au moins {min} caractères',
      maxLength: 'Ce champ ne doit pas dépasser {max} caractères',
      positiveNumber: 'Le montant doit être positif'
    },
    create: 'Créer',
    update: 'Mettre à jour',
    cancel: 'Annuler',
    submitting: 'Enregistrement...'
  },
  columns: {
    name: 'Nom',
    email: 'Email',
    phone: 'Téléphone',
    address: 'Adresse',
    notes: 'Notes',
    isActive: 'Statut',
    solde: 'Solde',
    createdAt: 'Créé le',
    updatedAt: 'Mis à jour le',
    lastSync: 'Dernière synchronisation',
    basicInfo: 'Informations de base',
    financialInfo: 'Détails financiers',
    systemInfo: 'Informations système'
  },
  filters: {
    search: {
      label: 'Rechercher',
      placeholder: 'Rechercher un client...'
    },
    status: {
      label: 'Statut',
      active: 'Actif',
      inactive: 'Inactif'
    }
  },
  actions: {
    newCustomer: 'Nouveau client',
    edit: 'Modifier',
    delete: 'Supprimer',
    view: 'Voir'
  },
  confirmations: {
    delete: 'Êtes-vous sûr de vouloir supprimer ce client ?',
    deleteSuccess: 'Client supprimé avec succès',
    createSuccess: 'Client créé avec succès',
    updateSuccess: 'Client mis à jour avec succès'
  },
  errors: {
    load: 'Erreur lors du chargement des clients',
    create: 'Erreur lors de la création du client',
    update: 'Erreur lors de la mise à jour du client',
    delete: 'Erreur lors de la suppression du client'
  },
  pagination: {
    totalItems: 'Total des éléments',
    previous: 'Précédent',
    next: 'Suivant',
    page: 'Page',
    showing: 'Affichage de',
    to: 'à',
    of: 'sur',
    items: 'éléments'
  },
  currency: 'Dh'
}; 